import { render, staticRenderFns } from "./BetgameEditUserSettings.vue?vue&type=template&id=8ff1d0ce&scoped=true"
import script from "./BetgameEditUserSettings.vue?vue&type=script&lang=js"
export * from "./BetgameEditUserSettings.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditUserSettings.vue?vue&type=style&index=0&id=8ff1d0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff1d0ce",
  null
  
)

export default component.exports